import { render, staticRenderFns } from "./CrimePrevention.vue?vue&type=template&id=0f3927fa"
import script from "./CrimePrevention.vue?vue&type=script&lang=js"
export * from "./CrimePrevention.vue?vue&type=script&lang=js"
import style0 from "./CrimePrevention.vue?vue&type=style&index=0&id=0f3927fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports